import { render, staticRenderFns } from "./driver_scorecard.vue?vue&type=template&id=2d45e864&scoped=true&"
import script from "./driver_scorecard.vue?vue&type=script&lang=js&"
export * from "./driver_scorecard.vue?vue&type=script&lang=js&"
import style0 from "./driver_scorecard.vue?vue&type=style&index=0&id=2d45e864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45e864",
  null
  
)

export default component.exports